import { createElement } from 'react';
import { Slider } from '@alifd/next';
import './index.scss';
const SliderImg = function DCSlider(props) {
    console.log('slider', props.picUrls);
    const { style } = props;
    return (createElement(Slider, { ...props }, props.picUrls && props.picUrls.length > 0 ?
        props.picUrls.map((url, index) => createElement("img", { src: url, alt: `Slide`, key: index, className: "slider-img", style: style }))
        : createElement("div", null, "\u56FE\u7247\u4E3A\u7A7A")));
};
export default SliderImg;
